import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CHROME_STORE_URL, ZIP_FALLBACK_HREF } from "@/lib/chromeStore";

const STEPS = [
  {
    title: "Add MinutePay to Chrome",
    body: "Open the Chrome Web Store listing and click Add to Chrome.",
  },
  {
    title: "Sign in with your MinutePay account",
    body: "Open the extension and sign in with the same account you use on this site.",
  },
  {
    title: "Open InterpreterCloud / LSA and start working",
    body: "Take a call as usual. MinutePay tracks eligible InterpreterCloud / LSA calls automatically.",
  },
];

export default function InstallPage() {
  return (
    <div className="mpd-page">
      <div className="mpd-page-head">
        <div>
          <p className="mpd-kicker">Onboarding</p>
          <h1>Install MinutePay</h1>
          <p className="mpd-sub">
            Add MinutePay from the Chrome Web Store, sign in, and start tracking. No ZIP file required.
          </p>
        </div>
      </div>

      <article className="mpd-card mpd-install-hero">
        <Button asChild className="mpd-install-download">
          <a href={CHROME_STORE_URL} target="_blank" rel="noopener noreferrer">
            Add MinutePay to Chrome
          </a>
        </Button>
      </article>

      <article className="mpd-card">
        <h2>Installation steps</h2>
        <ol className="mpd-install-steps">
          {STEPS.map((step, i) => (
            <li key={step.title}>
              <span className="mpd-install-num">Step {i + 1}</span>
              <strong>{step.title}</strong>
              <p>{step.body}</p>
            </li>
          ))}
        </ol>
      </article>

      <article className="mpd-card">
        <h2>Troubleshooting</h2>
        <ul className="mpd-install-tips">
          <li>Use Google Chrome.</li>
          <li>Sign in to the extension with the same MinutePay account you use on this site.</li>
          <li>Make sure your trial or license still has access.</li>
          <li>If MinutePay does not appear after installing, open chrome://extensions and confirm it is enabled.</li>
        </ul>
      </article>

      <details className="mpd-card mpd-install-fallback">
        <summary>Having trouble with the Chrome Web Store? (support fallback)</summary>
        <p>
          The Chrome Web Store is the supported way to install MinutePay. The ZIP / Load unpacked
          path is only a fallback if the store listing cannot be used. Contact support@minutepaytracker.com
          if you need help.
        </p>
        <p>
          <a href={ZIP_FALLBACK_HREF} download="MinutePay-extension.zip">
            Download ZIP (support fallback)
          </a>
        </p>
      </details>

      <div className="mpd-install-cta">
        <Button asChild>
          <Link to="/dashboard">{"I've installed MinutePay"}</Link>
        </Button>
      </div>
    </div>
  );
}
